import React from "react";
import { ReactComponent as AddNew } from "../../icons/add-new.svg";
import { ReactComponent as Trash } from "../../icons/trash.svg";
import { ReactComponent as Toggle } from "../../icons/toggle.svg";
import { ReactComponent as Collapse } from "../../icons/collapse.svg";
import { ReactComponent as Dashboard } from "../../icons/menu/dashboard.svg";
import { ReactComponent as Jobs } from "../../icons/menu/jobs.svg";
import { ReactComponent as Users } from "../../icons/menu/users.svg";
import { ReactComponent as Project } from "../../icons/menu/project.svg";
import { ReactComponent as SewerObjects } from "../../icons/menu/sewer-objects.svg";
import { ReactComponent as Subscription } from "../../icons/menu/subscription.svg";
import { ReactComponent as Settings } from "../../icons/menu/settings.svg";
import { ReactComponent as Edit } from "../../icons/edit.svg";
import { ReactComponent as DragDrop } from "../../icons/drag_and_drop.svg";
import { ReactComponent as Close } from "../../icons/close.svg";
import { ReactComponent as Info } from "../../icons/info.svg";
import { ReactComponent as LogoWhite } from "../../icons/logo-white.svg";
import { ReactComponent as LogoBlack } from "../../icons/logo-black.svg";
import { ReactComponent as BreadcrumbArrow } from "../../icons/breadcrumb-arrow.svg";
import { ReactComponent as HeaderProfile } from "../../icons/header-profile.svg";
import { ReactComponent as SignOut } from "../../icons/sign-out.svg";
import { ReactComponent as Success } from "../../icons/success.svg";
import { ReactComponent as Warning } from "../../icons/warning.svg";
import { ReactComponent as Error } from "../../icons/error.svg";
import { ReactComponent as Upload } from "../../icons/upload-new.svg";
import { ReactComponent as Question } from "../../icons/question.svg";
import { ReactComponent as AddJobs } from "../../icons/add-jobs.svg";
import { ReactComponent as Share } from "../../icons/share.svg";
import { ReactComponent as ChangePriority } from "../../icons/change-priority.svg";
import { ReactComponent as ChangeStatus } from "../../icons/change-status.svg";
import { ReactComponent as Assign } from "../../icons/assign.svg";
import { ReactComponent as AddTo } from "../../icons/add-to.svg";
import { ReactComponent as Filter } from "../../icons/filter.svg";
import { ReactComponent as Search } from "../../icons/search.svg";
import { ReactComponent as RunAI } from "../../icons/run-AI.svg";
import { ReactComponent as CopyURL } from "../../icons/copy-url.svg";
import { ReactComponent as Remove } from "../../icons/remove.svg";
import { ReactComponent as Download } from "../../icons/download.svg";
import { ReactComponent as Play } from "../../icons/videoPlayer/play.svg";
import { ReactComponent as Pause } from "../../icons/videoPlayer/pause.svg";
import { ReactComponent as Next } from "../../icons/videoPlayer/next.svg";
import { ReactComponent as Previous } from "../../icons/videoPlayer/previous.svg";
import { ReactComponent as Minimize } from "../../icons/videoPlayer/minimize.svg";
import { ReactComponent as Maximize } from "../../icons/videoPlayer/maximize.svg";
import { ReactComponent as Detach } from "../../icons/videoPlayer/detach.svg";
import { ReactComponent as Image } from "../../icons/image.svg";
import { ReactComponent as Undo } from "../../icons/undo.svg";
import { ReactComponent as Sort } from "../../icons/sort.svg";
import { ReactComponent as SecureEntry } from "../../icons/secure-entry.svg";
import { ReactComponent as ArrowLeft } from "../../icons/arrow-left.svg";
import { ReactComponent as ArrowRight } from "../../icons/arrow-right.svg";
import { ReactComponent as DottedArrowRight } from "../../icons/dotted-arrow-right.svg";
import { ReactComponent as Video } from "../../icons/video.svg";
import { ReactComponent as Minus } from "../../icons/minus.svg";
import { ReactComponent as Accept } from "../../icons/accept.svg";
import { ReactComponent as Reject } from "../../icons/reject.svg";
import { ReactComponent as Help } from "../../icons/menu/help.svg";
import { ReactComponent as CustomerSupport } from "../../icons/customer-support.svg";
import { ReactComponent as ExternalLink } from "../../icons/external-link.svg";
import { ReactComponent as Email } from "../../icons/email.svg";
import { ReactComponent as Address } from "../../icons/address.svg";
import { ReactComponent as TelFax } from "../../icons/tel-fax.svg";
import { ReactComponent as CurrentPlan } from "../../icons/current-plan.svg";
import { ReactComponent as StorageSpace } from "../../icons/storage-space.svg";
import { ReactComponent as UsersAndSeats } from "../../icons/users-and-seats.svg";
import { ReactComponent as VideoAnalysis } from "../../icons/video-analysis.svg";
import { ReactComponent as Hamburger } from "../../icons/hamburger.svg";
import { ReactComponent as Restore } from "../../icons/restore.svg";
import { ReactComponent as Detection } from "../../icons/detection.svg";
import { ReactComponent as Retry } from "../../icons/retry.svg";
import ResetDefaultZoom from "../../icons/map/reset-zoom-to-default.svg";
import MapStructure from "../../icons/map-structure.svg";
import MapStructureSelected from "../../icons/map-structure-selected.svg";
import MapNode from "../../icons/map-node.svg";
import MapNodeSelected from "../../icons/map-node-selected.svg";
import { ReactComponent as MarkRelevant } from "../../icons/mark-relevant.svg";
import { ReactComponent as MarkOutdated } from "../../icons/mark-obsolete.svg";
import { ReactComponent as MarkRelevantSmall } from "../../icons/mark-relevant-small.svg";

const mainMenuItems: { [key: string]: React.FunctionComponent } = {
  dashboard: Dashboard,
  jobs: Jobs,
  users: Users,
  projects: Project,
  "sewer-objects": SewerObjects,
  help: Help,
  subscription: Subscription,
  settings: Settings,
};

const logoEsic: { [key: string]: React.FunctionComponent } = {
  light: LogoWhite,
  dark: LogoBlack,
};

const logoEsicBackground: { [key: string]: React.FunctionComponent } = {
  light: LogoBlack,
  dark: LogoWhite,
};

export {
  AddNew,
  Trash,
  Toggle,
  Collapse,
  mainMenuItems,
  DragDrop,
  logoEsic,
  logoEsicBackground,
  Close,
  Info,
  BreadcrumbArrow,
  HeaderProfile,
  SignOut,
  Edit,
  Success,
  Warning,
  Error,
  Upload,
  Question,
  Jobs,
  AddJobs,
  Share,
  ChangePriority,
  ChangeStatus,
  Assign,
  AddTo,
  Filter,
  Search,
  RunAI,
  CopyURL,
  Remove,
  Download,
  Play,
  Pause,
  Next,
  Previous,
  Minimize,
  Maximize,
  Detach,
  Image,
  Undo,
  Sort,
  SecureEntry,
  ArrowLeft,
  ArrowRight,
  DottedArrowRight,
  Video,
  Minus,
  Accept,
  Reject,
  CustomerSupport,
  ExternalLink,
  Email,
  Address,
  TelFax,
  CurrentPlan,
  StorageSpace,
  UsersAndSeats,
  VideoAnalysis,
  Hamburger,
  Restore,
  Detection,
  Retry,
  MapStructure,
  MapStructureSelected,
  MapNode,
  MapNodeSelected,
  Settings,
  ResetDefaultZoom,
  MarkRelevant,
  MarkRelevantSmall,
  MarkOutdated,
};
